import { Button, Flex, NumberInput, TextInput } from "@mantine/core";
import { FormColumnHalf } from "../../common/Form/FormRow";
import Container from "../../common/Container";
import PageHeader from "../../common/PageHeader";
import { useForm } from "@mantine/form";
import { validateRequired } from "../../../utils/validations";
import { updateContractById, getContractById } from "../../../api/contractApi";
import { updateNotification } from "../../../utils/useNotification";
import CustomDatePicker from "../../common/Inputs/CustomDatePicker";
import { useNavigate, useParams } from "react-router";
import { useEffect, useRef } from "react";
import dayjs from "dayjs";
import SaveIcon from "../../common/Icons/SaveIcon";

const UpdateContract = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const formRef = useRef<HTMLFormElement>(null);

  const form = useForm<any>({
    initialValues: {
      name: "",
      monthlyHours: "",
      startDate: undefined,
      endDate: undefined,
    },
    validate: {
      name: validateRequired,
      monthlyHours: validateRequired,
    },
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data }: any = await getContractById({ id });
        const contract = data?.response;
        form.setValues({
          name: contract?.name ?? "",
          monthlyHours: contract?.monthlyHours ?? "",
          startDate: contract?.startDate ? dayjs(contract.startDate).toDate() : undefined,
          endDate: contract?.endDate ? dayjs(contract.endDate).toDate() : undefined,
        });
      } catch (error) {
        console.error("Error:", error);
      }
    };
    if (id) fetchData();
  }, [id]);

  const handleSubmit = async (values: object) => {
    try {
      const { data }: any = await updateContractById({ id, updates: values });
      if (data?.success) {
        updateNotification(data?.success);
        navigate(-1);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <Container>
      <PageHeader
        pageTitle="Kontrat Güncelle"
        isButtoned
        buttonText="Kaydet"
        buttonIcon={<SaveIcon />}
        buttonOnClick={() => formRef.current?.requestSubmit()}
      />
      <div style={{ display: "flex", flexDirection: "column", gap: "40px" }}>
        <form
          ref={formRef}
          style={{ display: "flex", flexDirection: "column", gap: "24px" }}
          onSubmit={form.onSubmit(handleSubmit)}
        >
          <FormColumnHalf>
            <TextInput
              label="Kontrat İsmi"
              placeholder="Kontrat İsmi Giriniz."
              maxLength={40}
              size="md"
              {...form.getInputProps("name")}
            />
            <NumberInput
              label="Aylık Çalışma Saati"
              placeholder="Örn: 10"
              hideControls
              size="md"
              {...form.getInputProps("monthlyHours")}
            />
            <CustomDatePicker
              label="Kontrat Başlangıç Tarihi"
              placeholder="Tarih Seçiniz."
              w="100%"
              size="md"
              {...form.getInputProps("startDate")}
            />
            <CustomDatePicker
              label="Kontrat Bitiş Tarihi"
              placeholder="Tarih Seçiniz."
              w="100%"
              size="md"
              {...form.getInputProps("endDate")}
            />
          </FormColumnHalf>
        </form>
      </div>
    </Container>
  );
};

export default UpdateContract;